import { render, staticRenderFns } from "./OaDocModal.vue?vue&type=template&id=34dfcde0"
import script from "./OaDocModal.vue?vue&type=script&lang=js"
export * from "./OaDocModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports